import {
  buildRobloxGameRankDownloadApiParams,
} from '@intelligence/v3/pages/RobloxGameRank/utils/buildRobloxGameRankDownloadParams';
import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import { getFileNameCommon } from '@intelligence/components/DownloadCommon/DownloadPage/utils';

export default (params: Record<string, any>) => {
  return {
    ...commonSetting,
    downloadMode: 'commonConf',
    downloadConfigKey: 'robloxGameRank',
    downloadFetchApi: '/api/v1/intelligence_pc/game/roblox/ranks',
    downloadApiParams: buildRobloxGameRankDownloadApiParams(params),
    isUsingNewMethod: false,
    fetchOnlyOnce: true,
    dataKey: undefined,
    $$fileName: getFileNameCommon(params),
    regionOptions: params?.regionOptions,
  };
};
